import { render, staticRenderFns } from "./TechAreasPageEdit.vue?vue&type=template&id=c14811b4&"
import script from "./TechAreasPageEdit.vue?vue&type=script&lang=ts&"
export * from "./TechAreasPageEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c14811b4')) {
      api.createRecord('c14811b4', component.options)
    } else {
      api.reload('c14811b4', component.options)
    }
    module.hot.accept("./TechAreasPageEdit.vue?vue&type=template&id=c14811b4&", function () {
      api.rerender('c14811b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/TechAreas/TechAreasPageEdit.vue"
export default component.exports